<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">Set: {{ reference }} - Clonado de: {{ referenceClone }} {{ originLabel ? `Origen:
                    ${originLabel}` : ''
                    }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-text-field v-model="reference" label="Codigo-Referencia" outlined class="mb-3"
                                :disabled="isDisabled || reference === ''"></v-text-field>
                        </v-col>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete v-model="centerCost" :items="itemsCostCenters" label="Centro de Costo"
                                outlined auto-select-first></v-autocomplete>
                        </v-col>
                        <v-col cols="4" sm="4" md="4" class="pb-0">
                            <v-autocomplete v-model="position" :items="itemsPositions" label="Posicion / Cargo"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete v-model="zone" :items="itemsZones" label="Zona" :disabled="isDisabled"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>


                    </v-row>
                    <v-row>
                        <!-- <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete v-model="sex" :items="itemSex" label="Sexo" auto-select-first outlined
                                ref="cod"></v-autocomplete>
                        </v-col> -->
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field v-model="renovation" label="Renovacion Meses" outlined class="mb-3"
                                type="number" :disabled="disableRef"></v-text-field>
                        </v-col>

                        <v-col cols="7" sm="7" md="7" class="pb-0">
                            <v-autocomplete v-model="category" :items="itemsCategories" label="Categoria Producto"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field v-model="quantity" label="Cantidad" outlined required
                                type="number"></v-text-field>
                        </v-col>
                        <v-col cols="1" sm="1" md="1">
                            <v-icon color="success" @click="onList" v-text="'mdi-check-outline'"
                                :disabled="!isNewItemOk"></v-icon> -
                            <v-icon v-if="disableRef" color="warning" @click="onEdit"
                                v-text="'mdi-circle-edit-outline'"></v-icon>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" sm="4" md="4" class="pb-0">
                            <v-autocomplete v-model="positionOld" :items="uniquePositions"
                                label="Posicion / Cargo Anterior" auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>
                        <v-col cols="4" sm="4" md="4" class="pb-0">
                            <v-autocomplete v-model="positionNew" :items="itemsPositions" label="Posicion / Cargo Nuevo"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>
                        <v-col cols="1" sm="1" md="1">
                            <v-icon color="success" @click="onChangePositions" v-text="'mdi-check-outline'"
                                :disabled="!isNewPositionOk"></v-icon>
                        </v-col>
                    </v-row>
                    <br>
                    <v-data-table :headers="headers" :items="itemsAggregate" class="elevation-1 custom-font">
                        <template v-slot:item.flag="{ item }">
                            <v-icon :color="item.flag ? 'green' : 'red'">
                                {{ item.flag ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                            </v-icon>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-alert shaped dense dark type="error" v-if="!itemsOk">
                    En este centro de costo no existen estas posiciones / cargos
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="saveStock">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>
<script>
import { getCostCenters, getPositions, getKitById, getSex, getCategories, getInventoryZonesItems } from '@/dataApi'

export default {
    props: {
        kit: {
            type: Number,
            required: true
        }
    },
    name: 'kits',
    data: () => ({
        selectedRef: null,
        category: null,
        quantity: 0,
        centerCost: null,
        position: null,
        positionOld: null,
        positionNew: null,
        zone: null,
        reference: '',
        referenceClone: '',
        itemsProducts: [],
        itemsCategories: [],
        itemsCostCenters: [],
        itemsPositions: [],
        itemsPositionsNew: [],
        itemSex: [],
        itemsAggregate: [],
        itemsZones: [],
        renovation: 0,
        sex: null,
        disableRef: false,
        originLabel: null,
        headers: [
            { text: "", value: "flag" },
            { text: 'Sexo', value: 'sex' },
            { text: 'Posicion', value: 'position' },
            { text: 'Categoria Producto', value: 'category' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'Renovacion', value: 'renovation' },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        itemsOk: true,

    }),

    methods: {
        async createdValuesItems() {

            this.itemSex = getSex();
            //this.itemsProducts = await getProductsItems();
            this.itemsCategories = await getCategories();
            this.itemsCostCenters = await getCostCenters(true);
            //this.itemsPositions = await getPositions();
            this.itemsZones = await getInventoryZonesItems();

            if (this.kit > 0) {
                const kit = await getKitById(this.kit);

                this.referenceClone = kit.ref;
                // this.centerCost = kit.costCenter;
                // this.position = kit.items[0].position;
                this.sex = kit.items[0].sex;
                this.renovation = kit.items[0].durationMonths;
                this.zone = kit.zoneId;
                const itemsView = kit.items.map(item => {
                    return {
                        flag: true,
                        categoryId: item.category.id,
                        quantity: item.quantity,
                        position: item.position,
                        sex: item.sex,
                        renovation: item.durationMonths,
                        category: item.category.name
                    }
                })
                this.itemsAggregate = itemsView;
            }
        },

        async onList() {
            console.log("onList", this.position, this.positionNew)
            const quantity = parseInt(this.quantity)
            const category = this.itemsCategories.find(category => category.value === this.category)
            const exist = this.itemsAggregate.findIndex(item => item.categoryId === this.category && item.position === this.position
                && item.centerCost === this.centerCost)
            if (exist !== -1) {
                this.itemsAggregate[exist].quantity += quantity;
            } else {
                this.itemsAggregate.push({
                    categoryId: this.category,
                    category: category.text,
                    quantity,
                    position: this.position,
                    sex: 'U',
                    renovation: this.renovation,
                    reference: this.reference,
                    centerCost: this.centerCost
                });
            }
            this.category = null;
            this.disableRef = true;
            this.validateItems();
        },

        deleteItem(item) {
            const index = this.itemsAggregate.findIndex(ele => ele.categoryId === item.categoryId && ele.position === item.position && ele.sex === item.sex)
            if (index !== -1) {
                this.itemsAggregate.splice(index, 1);
            }
            this.validateItems();
        },

        onEdit() {
            this.disableRef = false;
            this.originLabel = null;
        },

        cancelStock() {
            this.$emit("closeModal", {})
        },

        saveStock() {
            const kits = {
                ref: this.reference,
                costCenter: this.centerCost,
                items: [],
                zoneId: this.zone
            }
            this.itemsAggregate.forEach(item => {
                kits.items.push({
                    sex: item.sex,
                    position: item.position,
                    categoryId: item.categoryId,
                    quantity: item.quantity,
                    durationMonths: parseInt(item.renovation)
                })
            })
            this.$emit("saveStock", kits)

        },
        closeModal() {
            this.getKitView = false;
            this.kitId = null;
            this.keyView++;
        },
        viewRequest(kit) {
            this.kitId = kit.id;
            this.keyView++;
            this.getKitView = true;
        },
        validateItems() {
            this.itemsOk = true;
            this.itemsAggregate.forEach(item => {
                item.flag = !!this.itemsPositions.find(position => position.value === item.position);
                if (!item.flag) this.itemsOk = item.flag;
            })
        },
        onChangePositions() {
            this.itemsAggregate.forEach(item => {
                if (item.position === this.positionOld) {
                    item.position = this.positionNew;
                }
            })
            this.positionOld = null;
            this.positionNew = null;
        }
    },

    mounted() {
        this.createdValuesItems();
    },

    watch: {
        async centerCost(newVal) {
            this.itemsOk = true;
            this.reference = `${newVal}-${Date.now().toString().slice(-6)}`
            this.itemsPositions = await getPositions(newVal)
            this.validateItems();
        },

        itemsPositions(newVal) {
            this.itemsPositionsNew = newVal;
        }
    },

    computed: {
        isNewItemOk() {
            return this.category !== null && parseInt(this.quantity) !== 0;
        },
        isOk() {
            return this.itemsAggregate.length > 0 && this.reference != '' && this.itemsOk;
        },
        isDisabled() {
            return this.itemsAggregate.length > 0
        },
        isNewPositionOk() {
            return this.positionOld !== null && this.positionNew !== null && this.positionOld !== this.positionNew;
        },
        uniquePositions() {
            if (!this.itemsAggregate || this.itemsAggregate.length === 0) {
                return [];
            }

            return [...new Set(this.itemsAggregate.map(item => item.position))];
        }
    }
}
</script>